import { render, staticRenderFns } from "./BackToVenueButton.vue?vue&type=template&id=5cd4633f&scoped=true&"
import script from "./BackToVenueButton.vue?vue&type=script&lang=js&"
export * from "./BackToVenueButton.vue?vue&type=script&lang=js&"
import style0 from "./BackToVenueButton.vue?vue&type=style&index=0&id=5cd4633f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd4633f",
  null
  
)

export default component.exports